/**
 * axios setup to use mock service
 */

import axios from 'axios';

const axiosServices = axios.create({
    headers: {
        Authorization: `Bearer ${localStorage.getItem('serviceToken')}`
    }
});

axiosServices.interceptors.request.use((config) => {
    const token = localStorage.getItem('serviceToken');

    if (!token) window.location.replace('/login');

    if (token && config && config.headers) {
        config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
});

export default axiosServices;
